import * as actions from './rfr-ord-search.actions';
import * as luxon from 'luxon';

import { createFeature, createReducer, on } from '@ngrx/store';

import { RfrOrdItemI } from 'src/app/api/rfr-ord-search/rfr-ord-item.int';
import { SharedStorageKeyEnum } from 'src/app/shared/_config/storage/shared-storage-key-enum';
import { SpxStorage } from '@softpak/components/spx-storage';

export interface State {
  error: string;
  loaded: boolean;
  loading: boolean;
  data: RfrOrdItemI[];
  receivedTime: string;
  tableView: boolean;
  query: string;
  lastOrderIds: number[];
  newOrderDetected: boolean;
  newOrderCheckActivated: boolean;
}

export const initialState: State = {
  error: null,
  loaded: false,
  loading: false,
  data: [],
  receivedTime: null,
  tableView: SpxStorage.getSetting(SharedStorageKeyEnum.rfrOrdTableView) ? true : false,
  query: null,
  lastOrderIds: [],
  newOrderDetected: false,
  newOrderCheckActivated: false,
};

export default createFeature({
  name: 'rfrOrdSearch',
  reducer: createReducer(
    initialState,
    on(actions.load, (state: State): State => ({
      ...state,
      loaded: false,
      loading: true
    })),
    on(actions.received, (state: State, { data }): State => {
      const newIds = data.map(order => order.seqNr) ?? [];
      const previousIds = state.lastOrderIds ?? [];
      const isNewOrderDetected = state.newOrderCheckActivated && newIds.some(id => !previousIds.includes(id));

      return {
        ...state,
        data,
        error: null,
        loaded: true,
        loading: false,
        receivedTime: luxon.DateTime.now().toISO(),
        lastOrderIds: newIds,
        newOrderDetected: isNewOrderDetected,
        newOrderCheckActivated: true,
      };
    }),
    on(actions.reset, (state: State): State => ({
      ...state,
      data: [],
      error: null,
      loaded: false,
      loading: false,
      query: null,
    })),
    on(actions.query, (state: State, { query }): State => ({
      ...state,
      query
    })),
    on(actions.error, (state: State, { messageText }): State => ({
      ...state,
      error: messageText,
      loaded: false,
      loading: false
    })),
    on(actions.switchView, (state: State, { tableView }): State => {
      if (tableView) {
        SpxStorage.setSetting(SharedStorageKeyEnum.rfrOrdTableView, "YES");
      } else {
        SpxStorage.clearSetting(SharedStorageKeyEnum.rfrOrdTableView);
      }
      return {
        ...state,
        tableView,
      };
    }),
  )
}
);
